<div class="container-fluid main-container landing pt-2">
    <div class="row mb-4">
        <div class="col-12 d-flex justify-content-end">
            <div class="d-flex">
                <button no-print type="button" class="btn">
                    <a class="text-white text-decoration-none" target="_blank"
                        href="https://apps.powerapps.com/play/e/0a961029-55fa-e507-ab6a-bef714598c53/a/d8aed6c4-2103-4b47-a1ae-8d396f69d990">
                        <i no-print class="fa-solid fa-arrow-up-right-from-square text-white" aria-hidden="true"></i>
                        Catalogo Servizi Professionali
                    </a>
                </button>
            </div>
        </div>
    </div>
    <div class="row my-5">
        <div class="col text-white text-center">
            <h1 class="mb-3">Scegli il tipo di offerta</h1>
            <h5>Scegli la nuova offerta e inizia il tuo percorso guidato</h5>
        </div>
    </div>
    <div class="row justify-content-center">
        <div class="col-lg-10 col-xl-8 col-12">
            @if (offerParamsForm$ | async; as offers) {
            <form [formGroup]="newOfferForm">
                <mat-horizontal-stepper [linear]="false" [headerPosition]="'bottom'" [disableRipple]="true" #stepper>
                    <mat-step>
                        <div class="row">
                            <div class="col text-white text-center">
                                <h3>Seleziona la tipologia di offerta</h3>
                            </div>
                        </div>
                        <div class="row mt-5">
                            <button class="bg-transparent border-0 text-grey float-right col-2" mat-button
                                [disabled]="true">
                                <i class="fas fa-4x fa-caret-left"></i>
                            </button>
                            <div class="col text-black">
                                <div class="form-group row justify-content-around">
                                    <select formControlName="area" class="form-control col-6 wizard-select" id="area">
                                        >
                                        <option disabled selected value="">Seleziona una tipologia...</option>
                                        @for (area of offers; track area) {
                                        <option [value]="area">
                                            {{ area }}
                                        </option>
                                        }
                                    </select>
                                </div>
                            </div>
                            <button (click)="skipSecondStep()"
                                class="bg-transparent border-0 text-white float-right col-2" mat-button
                                [disabled]="newOfferForm.get('area').invalid">
                                <i class="fas fa-4x fa-caret-right"></i>
                            </button>
                        </div>
                    </mat-step>
                    <mat-step>
                        <div class="row">
                            <div class="col text-white text-center">
                                <h3>Seleziona il pacchetto</h3>
                            </div>
                        </div>
                        <div class="row mt-5">
                            <button class="bg-transparent border-0 text-white float-left col-2" mat-button
                                matStepperPrevious>
                                <i class="fas fa-4x fa-caret-left"></i>
                            </button>
                            <div class="col text-black">
                                <div class="form-group row justify-content-around">
                                    <select formControlName="subArea" class="form-control col-6 wizard-select"
                                        id="subArea">
                                        <option disabled selected value="">Seleziona un pacchetto...</option>
                                        @for (subarea of subAreaOptions; track subarea) {
                                        <option [ngValue]="subarea">
                                            {{ subarea.templateDriveName }}
                                        </option>
                                        }
                                    </select>
                                </div>
                            </div>
                            <button class="bg-transparent border-0 text-white float-right col-2" mat-button
                                (click)="sendTemplateData()" [disabled]="newOfferForm.get('subArea').invalid">
                                <i class="fas fa-4x fa-caret-right"></i>
                            </button>
                        </div>
                    </mat-step>
                </mat-horizontal-stepper>
            </form>
            } @else {
            <app-loading [fullScreen]="true" [show]="true"></app-loading>
            }
        </div>
    </div>
    <div class="wave">
        <svg viewBox="0 0 500 150" preserveAspectRatio="none" class="w-100 h-100">
            <path d="M-1.41,92.27 C149.99,150.00 281.31,16.28 502.54,101.14 L500.00,0.00 L0.00,0.00 Z"
                style="stroke: none; fill: #0133a1"></path>
        </svg>
    </div>
</div>
<div class="background"></div>